import { appShadowRoot } from '../../common/elements';

export const showHideLoader = (loaderEl, show = false) => {
  if (show) {
    if (loaderEl && loaderEl.classList.contains('is-hidden')) {
      loaderEl.classList.remove('is-hidden');
    }
  } else if (loaderEl && !loaderEl.classList.contains('is-hidden')) {
    loaderEl.classList.add('is-hidden');
  }
};

export const removeImageLoader = () => {
  const imageLoader = appShadowRoot.querySelector('#img-loader');
  if (imageLoader) {
    imageLoader.remove();
  }
};
